// src/services/searchHistoryService.js
import { apiRequest } from "./apiService";

/**
 * Fetch search history for a user.
 * Adjust the URL to match your backend.
 */
export async function fetchSearchHistory(userId) {
  if (!userId) return [];

  return apiRequest(`/search-history?userId=${encodeURIComponent(userId)}`, {
    method: "GET",
  });
}
